export const createLocalesRequests = (client) => ({
    listLocales: async (params) => {
        const { data, meta, links } = await client.api.get("locales", {
            params: params,
        });
        return { data, meta, links };
    },
});
//# sourceMappingURL=index.js.map